import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Link, withRouter} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {isFunction} from 'lodash';

class DivTable extends Component {
    renderAction(item) {
        if (this.props.actions) {
            return (
                <div className="actions">
                    <label>Actions:</label>
                    <div>
                        {this.props.actions.map((action, i) => {
                            return (
                                <React.Fragment key={i}>
                                    {this.getAction(action, item)}
                                </React.Fragment>
                            );
                        })}
                    </div>

                </div>
            );
        }
    }

    getAction(action, item) {

        if (action.condition && !action.condition(item)) {
            return null;
        }

        if (action.onClick) {
            return (
                <FontAwesomeIcon onClick={action.onClick.bind(this, item[item["IDPropertyName"]])}
                                 title={action["type"]} icon={action["icon"]}/>
            );
        } else {
            let href = action["href"];

            if (href.includes(":id")) {
                href = href.replace(":id", item[item["IDPropertyName"]]);
            }

            return (
                <Link title={action["type"]} to={process.env.APP_ROOT + href}>
                    <FontAwesomeIcon icon={action["icon"]}/>
                </Link>
            );
        }
    }

    getCellRenderer(value, item) {
        if (isFunction(value)) {
            return value(item);
        } else {
            return item[value];
        }
    }

    render() {
        return (
            <div className="divTable">
                <div className="header">
                    {Object.entries(this.props.columns).map(([key, value], i) => {
                        return (
                            <div key={i}>{key}</div>
                        );
                    })}
                    {this.props.actions && <div>Actions</div>}
                </div>
                {this.props.array.map((item, i) => {
                    return (
                        <div key={i}>
                            {Object.entries(this.props.columns).map(([key, value], j) => {
                                return (
                                    <div key={j}>
                                        <label>{key}:</label>
                                        <div>{this.getCellRenderer(value, item)}</div>
                                    </div>
                                );
                            })}
                            {this.renderAction(item)}
                        </div>
                    );
                })}
            </div>
        );
    }
}

DivTable.propTypes = {
    columns: PropTypes.object.isRequired,
    array: PropTypes.array.isRequired,
    actions: PropTypes.array
};

DivTable.defaultProps = {
    columns: {},
    array: []
};

export default withRouter(DivTable);